"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.audioPlayer = exports.getPreloadSoundKey = void 0;
const audioPathNames_1 = require("@app/enums/audioPathNames");
const translations_1 = require("@app/routes/SpeechDevelopment/translations");
class AudioPlayer {
    constructor() {
        this.audioElements = {};
        this.currentAudio = null;
        this.preloadAudios();
    }
    preloadAudios() {
        // preload FEEDBACK_SOUNDS and ERROR_SOUNDS
        const loadSounds = (source) => {
            for (const langId in source) {
                const sounds = source[langId];
                for (const key in sounds) {
                    const audioUrl = sounds[key];
                    const audio = new Audio(audioUrl);
                    audio.load();
                    this.audioElements[`${langId}_${key}`] = audio;
                }
            }
        };
        loadSounds(audioPathNames_1.FEEDBACK_SOUNDS);
        loadSounds(translations_1.ERROR_SOUNDS);
    }
    playAudio(key, audioFromBackend) {
        this.stopAudio();
        return new Promise((resolve, reject) => {
            const audio = audioFromBackend ? new Audio(audioFromBackend) : this.audioElements[key];
            if (!audio) {
                console.error(`File ${key} not found`);
                reject();
                return;
            }
            this.currentAudio = audio;
            const playEndedHandler = () => {
                console.log('resolving audio promise');
                resolve();
                audio.removeEventListener('ended', playEndedHandler);
            };
            audio.addEventListener('ended', playEndedHandler);
            try {
                const speedSettings = JSON.parse(localStorage.getItem('speedSettings') || '');
                audio.playbackRate = (speedSettings === null || speedSettings === void 0 ? void 0 : speedSettings.exercise_speed) || 1;
                audio.play();
            }
            catch (error) {
                console.error(`Error while playing audio: ${key}`, error);
                reject(error);
            }
        });
    }
    stopAudio() {
        for (const key in this.audioElements) {
            const audio = this.audioElements[key];
            audio.pause();
            audio.currentTime = 0; // Сброс времени воспроизведения на начало
        }
        if (this.currentAudio) {
            this.currentAudio.pause();
            this.currentAudio.currentTime = 0;
        }
        this.currentAudio = null;
    }
}
/**
 * Возвращает ключ для доступа к предзагруженному аудио.
 * Пример: getPreloadSoundKey(1, 'correct') → "1_correct"
 */
const getPreloadSoundKey = (langId, key) => {
    return `${langId}_${key}`;
};
exports.getPreloadSoundKey = getPreloadSoundKey;
exports.audioPlayer = new AudioPlayer();
